import { Interval } from 'luxon';

import merchantGatewayApi from 'apis/merchant-gateway/api';
import { EntityType } from 'modules/access-control';
import { SortOrder } from 'modules/insights-v2/components/tables/types';

import { RatingsByVenueInsight, RatingsByVenueTableBackendSortableIds } from './types';
import { getBaseUrl, getDateRangeForApiCall } from '../utils';

export const getRatingsByVenueInsightForEntity = ({
  entityType,
  entityId,
  interval,
  cursor,
  sortBy = 'AVERAGE_RATING',
  sortOrder,
  limit = 80,
  locale,
}: {
  entityType: EntityType;
  entityId: string;
  interval: Interval;
  cursor?: string;
  sortBy?: RatingsByVenueTableBackendSortableIds;
  sortOrder?: SortOrder;
  /** Maximum value is 100, 20 is the default value on BE */
  limit?: number;
  locale: string;
}) => {
  return merchantGatewayApi
    .get<RatingsByVenueInsight>(`${getBaseUrl(entityType, entityId)}/ratings-by-venue`, {
      headers: { 'Accept-Language': locale },
      params: {
        ...getDateRangeForApiCall(interval),
        cursor,
        sort_by: sortBy,
        sort_order: sortOrder,
        limit,
      },
    })
    .then(response => response.data);
};
